module.exports = __webpack_public_path__ + "img/gamesdk1.3d74e99.png";